import React, { useEffect, useState } from 'react';
import { Layout, Drawer, Grid } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import NavBar from 'src/components/Navbar';
import { SideNavItems } from 'src/components/SideNav';
import { getProjects } from 'src/redux/features/projects/projectsSlice';
import {
  actions,
  fetchActivities,
  fetchAssignedProjects,
  fetchProjects,
  getActivities,
  getPreferences,
} from 'src/redux/features/session/slice';
import {
  fetchAllRoles,
  getUserRoles,
} from 'src/redux/features/users/usersSlice';
import { useAuth } from 'react-oidc-context';
import { parseRoles } from 'src/utils/helpers';
import { FullScreenLoader } from 'src/components/FullScreenLoader';
import ErrorPopup from 'src/components/ErrorPopUp';

const { useBreakpoint } = Grid;
const { Header, Sider, Content } = Layout;

const App = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const dispatch = useDispatch();
  const { showMenu } = useSelector(getPreferences);
  const auth = useAuth();
  const { status: projectStatus, loading: projectsLoading } =
    useSelector(getProjects);
  const { status: activityStatus, loading: activitiesLoading } =
    useSelector(getActivities);

  const userRoles = useSelector(getUserRoles);
  const screens = useBreakpoint();

  const handleClose = () => {
    dispatch(actions.setOffCanvasMenu());
  };

  useEffect(() => {
    if (activityStatus === 'idle' && !activitiesLoading) {
      dispatch(fetchActivities());
    }
  }, [activityStatus, dispatch]);

  useEffect(() => {
    if (projectStatus === 'idle' && !projectsLoading) {
      dispatch(fetchAssignedProjects());
    }
  }, [projectStatus, dispatch]);

  const { status: getProjectStatus, loading: getAllProjectsLoading } =
    useSelector(getProjects);

  useEffect(() => {
    if (getProjectStatus === 'idle' && !getAllProjectsLoading) {
      dispatch(fetchProjects());
      console.log('fetchProjects', typeof fetchProjects());
    }
  }, [getProjectStatus, dispatch, getAllProjectsLoading]);

  useEffect(() => {
    if (
      !userRoles.data.length &&
      auth.user?.profile?.email &&
      auth.user?.profile?.role
    ) {
      dispatch(
        fetchAllRoles({
          email: auth.user.profile.email,
          roles: parseRoles(auth.user.profile.role as string),
        }),
      );
    }
  }, [
    auth.user?.profile?.email,
    auth.user?.profile?.role,
    userRoles.data.length,
    dispatch,
  ]);

  useEffect(() => {
    const pathsToCollapse = ['/manage-po', '/po-receiving', '/timesheet'];
    const shouldCollapse = pathsToCollapse.includes(location.pathname);

    setCollapsed(shouldCollapse);
  }, [location.pathname]);

  if (!userRoles || !userRoles.data.length) {
    return <FullScreenLoader />;
  }

  return (
    <Layout style={{ height: '100vh' }}>
      <NavBar />
      <Layout>
        <Layout>
          <ToastContainer transition={Slide} />
          <ErrorPopup />

          {screens.lg && (
            <Sider
              collapsible
              collapsed={collapsed}
              onCollapse={(value) => setCollapsed(value)}
              width={screens.xxl ? '250' : '220'}
              collapsedWidth={60}
              theme="light"
            >
              <SideNavItems />
            </Sider>
          )}
          <Layout>
            <Content
              style={{
                padding: '8px 16px',
                margin: 0,
              }}
            >
              <Outlet />
            </Content>
          </Layout>
        </Layout>
        <Drawer
          placement="left"
          closable={false}
          onClose={handleClose}
          open={showMenu}
          width={250}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: 0 }}
        >
          <SideNavItems />
        </Drawer>
      </Layout>
    </Layout>
  );
};

export default App;
